/*
 * Twix v1.0 - a lightweight library for making AJAX requests.
 * Author: Neil Cowburn (neilco@gmail.com)
 *
 * Copyright (c) 2013 Neil Cowburn (http://github.com/neilco/)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
const ajax = (options) => {
  options = options || { url: "" };
  options.type = options.type || "GET";
  options.headers = options.headers || {};
  options.timeout = parseInt(options.timeout) || 0;
  options.success = options.success || function () {};
  options.error = options.error || function () {};
  options.async = typeof options.async === "undefined" ? true : options.async;

  var client = new XMLHttpRequest();
  if (options.timeout > 0) {
    client.timeout = options.timeout;
    client.ontimeout = function () {
      options.error("timeout", "timeout", client);
    };
  }
  client.open(options.type, options.url, options.async);

  for (var i in options.headers) {
    if (options.headers.hasOwnProperty(i)) {
      client.setRequestHeader(i, options.headers[i]);
    }
  }
  try {
    client.send(options.data);
  } catch (clientError) {
    // console.log('Error', clientError);
    options.error(clientError);
  }
  client.onreadystatechange = function () {
    // console.log('TWIX CLIENT STATE CHANGED', this.status, this.readyState);
    if (this.readyState == 4 && this.status == 200) {
      var data = this.responseText;
      var contentType = this.getResponseHeader("Content-Type");
      if (contentType && contentType.match(/json/)) {
        data = JSON.parse(this.responseText);
      }
      options.success(data, this.statusText, this);
    } else if (this.readyState == 4) {
      options.error(this.status, this.statusText, this);
    }
  };
  if (options.async == false) {
    if (client.readyState == 4 && client.status == 200) {
      options.success(client.responseText, client);
    } else if (client.readyState == 4) {
      options.error(client.status, client.statusText, client);
    }
  }

  return client;
};

export const Twix = {
  ajax,
  get: (url, data, callback) => {
    if (typeof data === "function") {
      callback = data;
      data = undefined;
    }

    return ajax({
      url: url,
      data: data,
      success: callback,
    });
  },

  post: (url, data, callback) => {
    if (typeof data === "function") {
      callback = data;
      data = undefined;
    }

    return ajax({
      url: url,
      type: "POST",
      data: data,
      success: callback,
    });
  },
};
